// Compact relative-time formatting shared by portal list/detail pages
export const formatTimeAgo = (date) => {
  if (!date) return '';
  const t = new Date(date).getTime();
  if (!Number.isFinite(t)) return '';

  const seconds = Math.floor((Date.now() - t) / 1000);
  if (seconds < 60) return 'Just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  return new Date(t).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(new Date(t).getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}),
  });
};
